/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PackListIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const packListIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const packListIndexFetchPackListIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const packListIndexFetchPackListIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const packListIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const packListIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const packListIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PackListIndexTypes.PACK_LIST_INDEX_RESET_TIMESTAMP]: packListIndexResetTimestamp,
  [PackListIndexTypes.PACK_LIST_INDEX_FETCH_PACK_LIST_INDEX_LOADING]: packListIndexFetchPackListIndexLoading,
  [PackListIndexTypes.PACK_LIST_INDEX_FETCH_PACK_LIST_INDEX_SUCCESS]: packListIndexFetchPackListIndexSuccess,
  [PackListIndexTypes.PACK_LIST_INDEX_ADD_SELECTED_DOCUMENTS]: packListIndexAddSelectedDocuments,
  [PackListIndexTypes.PACK_LIST_INDEX_REMOVE_SELECTED_DOCUMENTS]: packListIndexRemoveSelectedDocuments,
  [PackListIndexTypes.PACK_LIST_INDEX_SET_WORKSPACE_VISIBLE]: packListIndexSetWorkspaceVisible
});
